<template>
  <section>
    <v-dialog
      v-model="warningDialog"
      max-width="500">
      <v-card>
        <v-card-title class="headline green darken-2 white--text">Atenção</v-card-title>

        <v-card-text>
          Deseja Remover Tipo de Documento do Checklist? Essa ação não poderá ser desfeita.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="error darken-2"
            flat
            @click="warningDialog = false">
            Cancelar
          </v-btn>

          <v-btn
            color="green darken-2"
            flat
            @click="remove()"
          >
            Prosseguir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-btn flat icon>
      <v-icon small @click="warningDialog = true">
        mdi-delete
      </v-icon>
    </v-btn>

  </section>
</template>


<script>
import { pullAllWith, isEqual } from 'lodash';
import ChecklistService from '@/services/applications/configurations/ChecklistService';

export default {
  name: 'RemoveDocumentTypeFromChecklist',
  components: {},
  props: ['item', 'typology', 'checklistIndex'],
  data() {
    return {
      warningDialog: false,
    };
  },
  methods: {
    remove() {
      const checklist = this.typology.checklists[this.checklistIndex];
      ChecklistService
        .removeDocumentType(checklist.id, this.item.id)
        .then(() => {
          const selected = { ...this.item };
          let documentTypesFiltred = [...checklist.document_types];
          documentTypesFiltred = pullAllWith(documentTypesFiltred, [selected], isEqual);
          checklist.document_types = documentTypesFiltred;
          this.warningDialog = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
